export const customLevelIconNames = [
	"toeic-basic",
	"toeic-intermediate",
	"toeic-advanced",
] as const;

export type CustomLevelIconName = (typeof customLevelIconNames)[number];

export const isCustomLevelIconName = (
	value: string,
): value is CustomLevelIconName =>
	(customLevelIconNames as readonly string[]).includes(value);
